import { Box, createTheme, ThemeProvider, Typography } from '@mui/material';
import './App.css';
import Main from './sections/Main';
import Highlights from './sections/Highlights';
import Experience from './sections/Experience';
import Testimonial from './sections/Testimonial';
import NavBar from './components/NavBar';
import { useState } from 'react';
import Footer from './sections/Footer';

const App = () => {
  const [mode, setMode] = useState<'light' | 'dark'>('light');
  const theme = createTheme({
    palette: {
      mode,
      primary: {
        main: '#000',
        contrastText: '#fff',
      },
    },
    typography: {
      fontFamily: 'Lora',
      h1: { fontFamily: 'Instrument Serif', fontSize: '9rem' },
      h2: { fontFamily: 'Instrument Serif', fontStyle: 'italic' },
      h3: { fontFamily: 'Instrument Serif', fontStyle: 'italic' },
    },
    components: {
      MuiButton: {
        styleOverrides: {
          root: {
            textTransform: 'none',
          },
        },
      },
      MuiLink: {
        styleOverrides: {
          root: {
            textDecoration: 'underline dotted',
            textUnderlineOffset: '4px', // space between text and underline
            transition: 'all 0.3s ease-in-out',
            textDecorationColor: 'white',
            '&:hover': {
              textDecorationColor: 'currentColor', // animate underline color
            },
          },
        },
      },
    },
  });
  return (
    <ThemeProvider theme={theme}>
      <NavBar
        toggleTheme={() => setMode(prev => (prev === 'light' ? 'dark' : 'light'))}
        isDarkMode={mode === 'dark'}
      />
      <Box sx={{ maxWidth: 600, margin: '100px auto' }}>
        <Main />
        <Highlights />
        <Testimonial />
        <Experience />
        <Footer />
      </Box>
    </ThemeProvider>
  );
};

export default App;
